// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flex_wrapper__x_vXW","image":"flex_image__htSET","content":"flex_content__pdPBp","reverse":"flex_reverse__vaXbd"};